import miniaCrowsEulogy from "../assets/images/Miniatures/minia-crows.png";
import miniaNewsPaperScissors from "../assets/images/Miniatures/minia-nps.png";
import miniaChaumiere from "../assets/images/Miniatures/minia-chaumiere.png";
import miniaEveryBreakingWave from "../assets/images/Miniatures/minia-ebw.png";
//import miniaScimitar from "../assets/images/Miniatures/minia-scimi.png";
//import miniaBlazingSky from "../assets/images/Miniatures/minia-bsky.png";
import miniaToThePeak from "../assets/images/Miniatures/minia-ttp.png";
//import miniaSemaphore from "../assets/images/Miniatures/minia-sema.png";
import miniaJackpot from "../assets/images/Miniatures/minia-jackpot.png";

const gamesData = [
    { slug: "crows-eulogy", image: miniaCrowsEulogy, texte: "Crow's Eulogy", sousTexte: "Projet Synthèse - NAD"},
    { slug: "to-the-peak", image: miniaToThePeak, texte: "To the Peak", sousTexte: "7DaysFPS Jam" },
    { slug: "news-paper-scissors", image: miniaNewsPaperScissors, texte: "News, Paper, Scissors", sousTexte: "Creative Jam 2024" },
    { slug: "every-breaking-wave", image: miniaEveryBreakingWave, texte: "Every Breaking Wave", sousTexte: "Wonderjam #5" },
    //{ slug: "scimitar", image: miniaScimitar, texte: "Scimitar", sousTexte: "Action Adventure Game" },
    //{ slug: "blazing-sky", image: miniaBlazingSky, texte: "Blazing Sky", sousTexte: "Untitled Game Jam" },
    { slug: "chaumiere", image: miniaChaumiere, texte: "Douce Chaumiere", sousTexte: "Projet UX - NAD" },
    //{ slug: "semaphore", image: miniaSemaphore, texte: "Semaphore", sousTexte: "UntitledGameJam #73" },
    { slug: "jackpot", image: miniaJackpot, texte: "Jackpot", sousTexte: "Creative Jam 2025" },
];

export default gamesData;
